var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailPlane2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 67,
    viewBox: "0 0 61 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4688 29.7368L25.5289 9.42685L20.7718 32.8204L28.4688 29.7368Z",
    fill: "#0CF2DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5994 24.4348L25.5293 9.42708L28.4692 29.737L24.1507 62.6769L43.5994 24.4348Z",
    fill: "#B9DAF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1506 62.6764L28.4691 29.7366L20.7721 32.8202L5.70067 38.8607L24.1506 62.6764Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7422 18.248L43.5993 24.4344L24.1506 62.6765L59.7422 18.248Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1506 62.6765L28.4691 29.7367L25.5292 9.42671L43.5993 24.4344L59.7422 18.248L24.1506 62.6765Z",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5995 24.4352L24.1508 62.6773L5.7008 38.8617L20.7722 32.8211L28.4693 29.7375",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5289 9.42635L20.7718 32.8199",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPlane2);
export default __webpack_public_path__ + "static/media/email-plane-2.91dbd976d52bb5282db009bad2a9599b.svg";
export { ForwardRef as ReactComponent };